<template>
  <div class="container">

    <b-form-group>
      <label class="required-label" for=""></label>
      <div class="d-flex">
        <b-form-radio :value="'format_only'" class="ml-1" v-model="copy_by">Copy Template</b-form-radio>
        <b-form-radio class="ml-5" v-if="!openFromExamController" :value="'question_with_format'" v-model="copy_by">Copy Template With
          Questions</b-form-radio>
      </div>
    </b-form-group>

    <b-form-group v-if="copy_by == 'format_only'">
      <label class="required-label" for=""></label>
      <div class="d-flex">
        <b-form-radio :value="'saved_template'" class="ml-1" v-model="template_from">From Saved Template</b-form-radio>
        <b-form-radio class="ml-5" v-if="!openFromExamController" :value="'previous_paper'" v-model="template_from">From Previous Question Paper</b-form-radio>
      </div>
    </b-form-group>

    <b-form-group v-if="template_from =='saved_template'">
      <label class="required-label" for="">Choose Template:</label>
      <div v-if="templates.length">
        <b-form-radio v-for="(template, index) in templates" v-model="template_id" :value="template.value" :key="index">{{ template.text }} -<b-link @click="preview(template.value)">View</b-link>
        </b-form-radio>
      </div>
      <div v-else>
        <p class="text-danger">No template created in programme configuration.</p>
      </div>
    </b-form-group>

    <b-modal id="templatePreviewModal" title="Template Preview" size="xl" hide-footer>
      <div v-if="previewLoading" class="text-center py-4">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <iframe v-else-if="previewPdfUrl" :src="previewPdfUrl" style="width:100%;height:80vh;border:none;"></iframe>
    </b-modal>

    <b-form-group v-if="(template_from=='previous_paper' || copy_by == 'question_with_format')">
      <label class="required-label" for="">Choose Academic Year to be copied from:</label>
      <b-form-select :options="$acedemicYears" v-model="academic_year">
      </b-form-select>
    </b-form-group>

    <b-form-group v-if="academic_year">
      <label class="required-label" for="">Choose Programme:</label>
      <b-form-select @change="getSchemes(usergroup_id)" :options="usergroups" v-model="usergroup_id">
      </b-form-select>
    </b-form-group>

    <b-form-group v-if="(academic_year && usergroup_id)">
      <label class="required-label" for="">Choose Scheme</label>
      <b-form-select @change="getSubgroups()" :options="schemeOptions" v-model="scheme">
      </b-form-select>
    </b-form-group>

    <b-form-group v-if="(academic_year && usergroup_id && scheme)">
      <label class="required-label" for="">{{ 'Choose ' + subgroupCustomName + ':'
      }}</label>
      <b-form-select @change="getCourses()" :options="usersubgroups" v-model="usersubgroup_id"
        :disabled="false"></b-form-select>
    </b-form-group>

    <b-form-group v-if="(academic_year && usergroup_id && usersubgroup_id)">
      <label class="required-label" for="">Choose Course:</label>
      <b-form-select @change="getActivities()" :options="courses" v-model="course_id">
      </b-form-select>
    </b-form-group>

    <b-form-group v-if="(academic_year && usergroup_id && usersubgroup_id && course_id)">
      <label class="required-label" for="">Choose Activity to be copied:</label>
      <b-form-select :options="exams" v-model="exam_id">
      </b-form-select>
    </b-form-group>

    <div class="mt-3 text-right">
      <!-- <b-button variant="success" class="mr-2" size="sm" @click="copyQuestion(true)">Copy question</b-button> -->
      <b-button variant="success" size="sm" @click="copyQuestion()">Proceed to copy</b-button>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    examId: {},
    courseId: {},
    programme_config_group_id: {},
    finishEditQuestion: Function,
    openFromExamController: Boolean
  },
  async created() {
    this.subgroupCustomName = this.$store.getters.getCustomNamings.userSubgroup.custom_name ?? "Usersubgroup";
    this.getUserGroups();
    this.getTemplates();
    // await Promise.all([
    // ]);
  },
  computed: {
  },
  components: {
  },
  data() {
    return {
      fetchData: false,
      subgroupCustomName: '',
      previewPdfUrl: null,
      previewLoading: false,

      courses: [],
      usersubgroups: [],
      usergroups: [],
      exams: [],
      templates: [],

      copy_by: null,//question_with_format, format_only
      template_from : null,
      template_id: null,
      academic_year: null,
      usersubgroup_id: null,
      usergroup_id: null,
      course_id: null,
      exam_id: null,
      scheme: null,
      schemeOptions: [],
    };
  },
  watch: {
    template_from() {
      this.academic_year= null;
      this.usersubgroup_id= null;
      this.usergroup_id= null;
      this.course_id= null;
      this.exam_id= null;
      this.scheme= null;
      this.schemeOptions= [];
      this.template_id = null;
    },
    copy_by(){
      this.academic_year= null;
      this.usersubgroup_id= null;
      this.usergroup_id= null;
      this.course_id= null;
      this.exam_id= null;
      this.scheme= null;
      this.schemeOptions= [];
      this.template_id = null;
      this.template_from = null;
    }
  },
  methods: {
    async copyQuestion() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/examquestions/copy`;
      let is_template = false;
      if(this.template_from == 'saved_template') { 
        this.exam_id = this.template_id; 
        is_template = true; 
      }
      await this.$axios
        .post(url, { copy_from_exam_id: this.exam_id, copy_to_exam_id: this.examId, format_with_question: this.copy_by == 'question_with_format', is_template : is_template })
        .then(() => {
          this.finishEditQuestion();
        })
        .catch((error) => {
          error;
        });
    },

    async preview(templateId) {
      this.previewPdfUrl = null;
      this.previewLoading = true;
      this.$bvModal.show('templatePreviewModal');
      const url = this.$store.getters.getAPIKey.mainAPI + `/exams/templates/pdfexport`;
      try {
        const response = await this.$axios.post(url, { exam_id: templateId }, { responseType: 'arraybuffer' });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.previewPdfUrl = URL.createObjectURL(blob);
      } catch (error) {
        error;
      } finally {
        this.previewLoading = false;
      }
    },

    async getCourses() {
      this.courses = [];

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usersubgroups/${this.usersubgroup_id}/courses`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach((course) => {
            // if(this.courseId != course.id)
            this.courses.push({
              value: course.id,
              text: `${course.name} (${course.code})`,
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    async getTemplates(){

      console.log('subgroups', this.usersubgroups);
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/templates/question-paper?config_group_id=${this.programme_config_group_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          console.log('templates',response.data);
          response.data.forEach((template) => {
            // this.usersubgroupObjects[subgroup.id] = subgroup;
            this.templates.push({
              value: template.id,
              text: template.summary ? `${template.name} - ${template.summary}` : template.name,
            });
          });
        })
        .catch((error) => {
          error;
        });

    },
    async getSchemes(userGroupId) {
      this.scheme = null;
      this.schemeOptions = [];
      this.usersubgroups = [];
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups/schemes/${userGroupId}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.schemeOptions = Object.values(response.data).map(scheme => ({ value: scheme, text: scheme }));
        })
        .catch((error) => { error; });
    },

    async getSubgroups() {
      this.usersubgroups = [];
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/${this.usergroup_id}/usersubgroups?academic_year=${this.academic_year}&scheme=${this.scheme}`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach((subgroup) => {
            // this.usersubgroupObjects[subgroup.id] = subgroup;
            this.usersubgroups.push({
              value: subgroup.id,
              text: `${subgroup.name} (${subgroup.code})`,
            });
          });
        })
        .catch((error) => {
          error;
        });
    },

    async getUserGroups() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups?allusergroups=1`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach((group) => {
            this.usergroups.push({
              value: group.id,
              text: `${group.name} (${group.code})`,
            });
          });
        })
        .catch((error) => {
          error;
        });
    },

    async getActivities() {
      this.exams = [];

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.course_id}/exams?copy_question=1`;
      await this.$axios
        .get(url)
        .then((response) => {
          response.data.forEach((exam) => {
            this.exams.push({
              value: exam.id,
              text: `${exam.name}`,
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
  }
};
</script>

<style >

</style>
